import { render, staticRenderFns } from "./ContentsComp.vue?vue&type=template&id=45b0e236&scoped=true&"
import script from "./ContentsComp.vue?vue&type=script&lang=js&"
export * from "./ContentsComp.vue?vue&type=script&lang=js&"
import style0 from "./ContentsComp.vue?vue&type=style&index=0&id=45b0e236&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0e236",
  null
  
)

export default component.exports